import FormattedMessage from 'I18n/components/FormattedMessage';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { HR } from 'foundations-components/transitional/components/HR';
import { Image } from 'foundations-components/transitional/components/Image';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { Grid, GridItem } from 'foundations-components/transitional/components/Grid';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { MediaObject } from 'foundations-components/transitional/components/MediaObject';
import { SprocketIcon } from 'foundations-assets/icons/components/SprocketIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function AppReviewWizardHeader({
  appIconUrl,
  appName,
  isEditing
}) {
  return /*#__PURE__*/_jsxs(View, {
    marginInline: "500",
    as: "div",
    children: [/*#__PURE__*/_jsxs(Grid, {
      paddingBlock: "200",
      children: [/*#__PURE__*/_jsx(GridItem, {
        size: {
          md: 1,
          lg: 3
        },
        children: /*#__PURE__*/_jsx(View, {
          as: "span",
          display: "block",
          marginBlockStart: "400",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `marketplace-ui-reviews.write.${isEditing ? 'edit' : 'new'}`
          })
        })
      }), /*#__PURE__*/_jsx(GridItem, {
        size: {
          md: 10,
          lg: 6
        },
        children: /*#__PURE__*/_jsxs(TFlex, {
          direction: "row",
          align: "center",
          justify: "center",
          children: [/*#__PURE__*/_jsx(MediaObject, {
            align: "center",
            itemLeft: /*#__PURE__*/_jsx(Image, {
              alt: appName,
              "data-test-id": "app-wizard-header-image",
              src: appIconUrl,
              inlineSize: '40px',
              maxInlineSize: '40px',
              paddingBlockStart: "300"
            }),
            children: /*#__PURE__*/_jsx(Text, {
              as: "h7",
              margin: "0",
              paddingBlockStart: "300",
              children: appName
            })
          }), /*#__PURE__*/_jsx(Text, {
            as: "h7",
            marginInlineStart: "200",
            paddingBlockStart: "300",
            children: "+"
          }), /*#__PURE__*/_jsx(MediaObject, {
            align: "end",
            itemLeft: /*#__PURE__*/_jsx(IconHolder, {
              color: "fill-primary-default",
              icon: SprocketIcon,
              margin: "0",
              padding: "0",
              size: "900"
            }),
            spacing: "none",
            children: /*#__PURE__*/_jsx(Text, {
              as: "h7",
              margin: "0",
              marginBlockEnd: "400",
              children: "HubSpot"
            })
          })]
        })
      }), /*#__PURE__*/_jsx(GridItem, {
        size: {
          md: 1,
          lg: 3
        }
      })]
    }), /*#__PURE__*/_jsx(HR, {
      distance: "flush"
    })]
  });
}